"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePhoneNumber = parsePhoneNumber;
const libphonenumber_js_1 = require("libphonenumber-js");
const formatCountryCallingCode = (parsedPhoneNumber) => ({
    country_code: `+${parsedPhoneNumber.countryCallingCode}`,
    number: parsedPhoneNumber.nationalNumber,
    country: parsedPhoneNumber.country || "",
});
function parsePhoneNumber(inputPhoneNumber) {
    if (!inputPhoneNumber) {
        return;
    }
    // replace all non-digit chars except first plus and empty space
    const onlyDigitsNumber = inputPhoneNumber.replace(/(^[^+0-9])|((?!^)[^0-9 ])/g, "");
    // replace 00 with + before the phone number
    const phoneNumber = onlyDigitsNumber.startsWith("00") ? onlyDigitsNumber.replace(/^.{2}/g, "+") : onlyDigitsNumber;
    const parsedPhoneNumber = (0, libphonenumber_js_1.parsePhoneNumberFromString)(phoneNumber);
    if (parsedPhoneNumber && parsedPhoneNumber.country) {
        return formatCountryCallingCode(parsedPhoneNumber);
    }
    const textSearch = (0, libphonenumber_js_1.findPhoneNumbersInText)(phoneNumber);
    if (textSearch && textSearch.length > 0) {
        const firstFound = textSearch[0];
        if (firstFound && firstFound.number.country) {
            return formatCountryCallingCode(firstFound.number);
        }
    }
}
//# sourceMappingURL=parsePhoneNumber.js.map